import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";

import { KEY_CODES } from "../../utils/helpers/keyCodes";
import { useEventListener, useSelector } from "../../utils/hooks";
import strings from "../../utils/strings";

interface OverlayPropsI {
	onOverlayHide: () => void;
}

export const Overlay = ({ onOverlayHide }: OverlayPropsI) => {
	const [isOpacityHidden, setIsOpacityHidden] = useState(true);
	const [isDisplayed, setIsDisplayed] = useState(false);
	const hideTimeoutRef = useRef<number | null>(null);

	const isVisible = useSelector((state) => state.popup.products.isVisible);

	const onOverlayClick = (event: React.MouseEvent) => {
		if (event.target === event.currentTarget) {
			onOverlayHide();
		}
	};

	const onEscapeKeyHandler = (event: KeyboardEvent) => {
		if (isVisible && isDisplayed && event.key === KEY_CODES.ESCAPE) {
			onOverlayHide();
		}
	};

	const showOverlay = () => {
		if (hideTimeoutRef.current) {
			window.clearTimeout(hideTimeoutRef.current);
			hideTimeoutRef.current = null;
		}

		setIsDisplayed(true);
		window.requestAnimationFrame(() => {
			setIsOpacityHidden(false);
		});
	};

	const hideOverlay = () => {
		if (hideTimeoutRef.current) {
			window.clearTimeout(hideTimeoutRef.current);
		}

		setIsOpacityHidden(true);
		hideTimeoutRef.current = window.setTimeout(() => {
			setIsDisplayed(false);
			hideTimeoutRef.current = null;
		}, 300);
	};

	useEffect(() => {
		if (isVisible) {
			showOverlay();
		} else {
			hideOverlay();
		}

		return () => {
			if (hideTimeoutRef.current) {
				window.clearTimeout(hideTimeoutRef.current);
				hideTimeoutRef.current = null;
			}
		};
	}, [isVisible]);

	useEventListener({
		type: "keydown",
		handler: onEscapeKeyHandler,
	});

	return (
		<button
			aria-label={strings.close}
			type="button"
			onClick={onOverlayClick}
			className={classNames({
				"addtocart-overlay": true,
				caas: true,
				show: !isOpacityHidden,
			})}
			style={{
				display: isDisplayed ? "block" : "none",
			}}
			tabIndex={-1}
		/>
	);
};
